var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 89",
    d: "M16.5 6V2M16.5 2H12.5M16.5 2L11.5 7",
    stroke: "#3D4128",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M15.5 11.25V11.25C15.5 11.947 15.5 12.2955 15.4424 12.5853C15.2056 13.7753 14.2753 14.7056 13.0853 14.9424C12.7955 15 12.447 15 11.75 15H9.5C6.67157 15 5.25736 15 4.37868 14.1213C4.37868 14.1213 4.37868 14.1213 4.37868 14.1213C3.5 13.2426 3.5 11.8284 3.5 9V6.75C3.5 6.05302 3.5 5.70453 3.55765 5.41473C3.79437 4.22466 4.72466 3.29436 5.91473 3.05764C6.20453 3 6.55302 3 7.25 3V3",
    stroke: "#3D4128",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.dcb5175589b2ed09aacee09257958578.svg";